/**
 * Motivos pelos quais um CNPJ pode ser considerado inválido.
 * Conforme IN RFB nº 2.229/2024.
 */
export enum MotivoCnpjInvalido {
  /** O valor informado é vazio (string vazia ou somente espaços/separadores). */
  Vazio = 'Vazio',
  /** O valor informado é nulo ou indefinido. */
  Nulo = 'Nulo',
  /** O CNPJ normalizado não possui exatamente 14 caracteres. */
  TamanhoInvalido = 'TamanhoInvalido',
  /** O CNPJ contém caracteres não permitidos (fora de [0-9A-Z]) nas posições 1 a 12. */
  CaracteresInvalidos = 'CaracteresInvalidos',
  /** Os dígitos verificadores (posições 13 e 14) não são numéricos. */
  DigitosVerificadoresNaoNumericos = 'DigitosVerificadoresNaoNumericos',
  /** Os dígitos verificadores calculados divergem dos informados. */
  DigitoVerificadorInvalido = 'DigitoVerificadorInvalido',
  /** O CNPJ é composto por uma sequência de dígitos repetidos (ex: 00000000000000). */
  SequenciaRepetida = 'SequenciaRepetida',
}
